import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/css/main.scss";
import App from "./App";
var root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
// const getIsOpened = () => {
//   let opened = getSessionStoragePrefs("window-open");
//   let activeTabname = getSessionStoragePrefs("widget_active_tab");
//   if (!opened || !activeTabname) return;
//   if (activeTabname == widgetFooterTabs.Messages) {
//     const activeChatType = getSessionStoragePrefs("opened-chat");
//     if (activeChatType && activeChatType == "new") {
//       removeSessionStoragePrefs("window-open");
//       removeSessionStoragePrefs("proactive-message");
//       removeSessionStoragePrefs("opened-chat");
//     }
//   }
// };
// getIsOpened();
root.render(_jsx(App, {}));
